import PropTypes from 'prop-types'
import React from 'react'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { setProfileAdsError, fetchUserInfo } from 'SRC/modules/users/Profile/actions'
import { getUserInfo } from 'src/modules/users/Profile/selectors'
import { updateAdById } from '../../../../actions'
import { connect } from 'react-redux'
import { adsStatues } from 'SRC/modules/ads/shared/constants'

export class Refresh extends React.PureComponent {
  getLimitExceededMessage () {
    let count = 1
    const userActiveAddons = this.props.user.activeAddons
    if (userActiveAddons && userActiveAddons.length) {
      const refreshAddon = userActiveAddons.find(addon => addon.action.label === 'refresh')
      if (refreshAddon) {
        count = refreshAddon.actionCount
      }
    }

    return `Već ste obnovili ${count} ${count > 1 ? 'oglasa' : 'oglas'}, 
      sledeći možete obnoviti za 48h od poslednje obnove, ili da aktivirate 
      REFRESH dodatak koji vam omogućava obnavljanje većeg broja oglasa. 
      Pogledajte sve DODATKE.`
  }

  getPeriodExpiredMessage () {
    return 'Već ste obnovili ovaj oglas u zadnjih 48h.'
  }

  refresh = async () => {
    if (this.props.isAvailable) {
      const helper = new CookiesHelper()
      const token = helper.get('token')
      const userId = helper.get('userId')
      const adId = this.props.adId
      if (token && userId && adId) {
        this.props.updateAdById(adId, {isLoading: true})
        const fields = {token, userId, adId}
        const api = new AdApi()
        const {status, message, errorCode} = await api.refresh(fields)
        if (status === AdApi.responseTypes.OK) {
          this.props.updateAdById(adId, {
            refreshed: new Date().toISOString(),
            status: adsStatues.PUBLISHED.code,
            isLoading: false
          })
          this.props.fetchUserInfo(userId, token, true)
        } else {
          if (errorCode === AdApi.RefreshResponseStatuses.REFRESH_LIMIT_WAS_EXCEEDED) {
            this.props.setProfileAdsError(this.getLimitExceededMessage())
          } else if (errorCode === AdApi.RefreshResponseStatuses.REFRESH_PERIOD_NOT_EXPIRED) {
            this.props.setProfileAdsError(this.getPeriodExpiredMessage())
          } else {
            this.props.setProfileAdsError(message)
          }
          this.props.updateAdById(adId, {isLoading: false})
        }
      }
    }
  }

  render () {
    const {isAvailable} = this.props
    return (
      <div className={`moji-oglasi-akcije-item ${isAvailable ? `` : `disabled`}`}>
        <a href='javascript:void(0)' onClick={this.refresh}><i className='ico-obnovi-oglas ico' /> Obnovi</a>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: getUserInfo(state)
  }
}

Refresh.propTypes = {
  isAvailable: PropTypes.bool.isRequired,
  adId: PropTypes.number.isRequired,
  updateAdById: PropTypes.func.isRequired,
  setProfileAdsError: PropTypes.func.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

Refresh.defaultProps = {
  isAvailable: true
}

export default connect(mapStateToProps, {updateAdById, setProfileAdsError, fetchUserInfo})(Refresh)
